import { atom } from 'jotai';

import type { CompanyFreeTextField } from '@/api/v4/organization.api';

type CompanyFreeTextFieldForm = Nullable<CompanyFreeTextField> & {
  id: string;
  synced: boolean;
};

export const companyFreeTextFields = atom<CompanyFreeTextFieldForm[]>([]);

export const companyFreeTextFieldsEditModeState = atom<string | null>(null);

// Company free text fields are now managed via React Query in use-company-free-text-fields.query.ts
